import i18n from '@/i18n'

export default {
    options: {
        perPage: 10,
        columnsDropdown: false,
        filterByColumn: false,
        highlightMatches: true,
        sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort',
        },
        pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll',
        },
        texts: {
            count: i18n.t('dataTable.count'),
            first: i18n.t('dataTable.first'),
            last: i18n.t('dataTable.last'),
            filter: null,
            filterPlaceholder: i18n.t('dataTable.filterPlaceholder'),
            limit: i18n.t('dataTable.limit'),
            page: i18n.t('dataTable.page'),
            noResults: i18n.t('dataTable.noResults'),
            filterBy: i18n.t('dataTable.filterBy'),
            loading: i18n.t('dataTable.loading'),
            defaultOption: i18n.t('dataTable.defaultOption'),
            columns: i18n.t('dataTable.columns'),
        },
    },
    theme: 'bootstrap4',
}
